import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { SalesforceConnectionStatus, SalesforceAuthInitiateResult, SalesforceMappingConfig } from '@/types/salesforce'

export const salesforceApi = {
    /** Get the OAuth authorization URL to open in a popup, connecting the company being viewed (ORB-899) */
    initiate: (clientCompanyId: string): Promise<ApiResponse<SalesforceAuthInitiateResult>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Initiate`),

    /** Check Salesforce connection status for a company */
    getStatus: (clientCompanyId: string): Promise<ApiResponse<SalesforceConnectionStatus>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Status`),

    /** Disconnect Salesforce for a company */
    disconnect: (clientCompanyId: string): Promise<ApiResponse<void>> =>
        apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Disconnect`, {}),

    /**
     * Get the campaign mapping configuration. The API fills in a row for every engagement state the
     * customer has not mapped, carrying the label OrbitalX would use, so the form always renders a
     * complete set whether or not anything has been saved.
     */
    getConfig: (clientCompanyId: string): Promise<ApiResponse<SalesforceMappingConfig>> =>
        apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Config`),

    /** Save the campaign mapping configuration. */
    saveConfig: (clientCompanyId: string, config: SalesforceMappingConfig): Promise<ApiResponse<void>> =>
        apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Integrations/Salesforce/Config`, config),
}
